import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';

import Price from '../Price/Price';
import {
  MealStyled, MealHeader, Name, MealName, PriceStyled, Description, AddMeal, MealIcon, Arrow, MealIconWrapper,
  Spinner, SpinnerContainer, Wrapper, Footer, AddMealLight, MealPic
} from './Meal.style';
import icon from '../../assets/images/image-icon.png';
import MealPhoto from '../MealPhoto/MealPhoto';
import {GoogleAnalyticsHelper} from '../../helpers/googleAnalytics.helper';
import {ANALYTICS_EVENT_CATEGORIES, ITEM_ORIGIN} from '../../constants/constant';

export class Meal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPhoto: false,
      showSpinner: false
    };
    this.onIconClicked = this.onIconClicked.bind(this);
    this.onMealClicked = this.onMealClicked.bind(this);
    this.onFooterClick = this.onFooterClick.bind(this);

    this.isDisabled = props.meal.disabledDays.length > 0 && props.meal.disabledDays.includes(moment().isoWeekday());
  }

  onIconClicked(e) {
    e.stopPropagation();
    this.setState({showPhoto: !this.state.showPhoto});
  }

  onMealClicked(e) {
    e.stopPropagation();
    const {meal,
      showMealModal,
      addItemStraightToBasket,
      restaurantModes,
      isOfflineMenu,
      handleShowDisabledMealModal,
      serverOffline,
      parent
    } = this.props;

    if (this.isDisabled) {
      handleShowDisabledMealModal(meal.disabledDays);
    } else if (meal.sizes.length === 1 && !meal.sizes[0].optionGroups.length) {
      if (restaurantModes.onlineOrdering && !isOfflineMenu && !serverOffline) {
        this.setState({showSpinner: true});
        const origin = parent === ANALYTICS_EVENT_CATEGORIES.UPSELL ? ITEM_ORIGIN.UPSELL : ITEM_ORIGIN.MENU;
        addItemStraightToBasket(meal, origin)
          .then(() => this.setState({showSpinner: false}));

        const GAmeal = {
          id: meal.uuid,
          name: meal.name,
          price: meal.price.toString(),
          quantity: 1,
          category: meal.categoryName || '',
          source: parent
        };
        GoogleAnalyticsHelper.addMeal(GAmeal, parent);
      }
    } else {
      showMealModal(meal, parent);
    }
  }

  onFooterClick() {
    const {meal, handleOpenPictureModal} = this.props;
    if (!meal.primaryImageUrl) {
      return;
    }
    handleOpenPictureModal({
      url: meal.primaryImageUrl,
      name: meal.name
    });
  }

  render() {
    const {meal, showMealAddButton, showMealMoreButton, compact, hideDropDownPic} = this.props;
    const {showSpinner} = this.state;

    let addMealContent;

    if (showMealAddButton && !showSpinner) {
      addMealContent = <FormattedMessage id="basket.addToBasket" />;
    } else if (showMealMoreButton && !showSpinner){
      addMealContent = <FormattedMessage id="basket.more" />;
    } else if (showSpinner) {
      addMealContent = <SpinnerContainer><Spinner /></SpinnerContainer>;
    }

    const renderImageIcon = !hideDropDownPic && meal.primaryImageUrl &&
      <MealIconWrapper
        onClick={this.onIconClicked}
        data-rw="menu-page--meal--photo-toggle"
      >
        <MealIcon src={icon} />
        <Arrow open={this.state.showPhoto} />
      </MealIconWrapper>;

    const renderPhoto = this.state.showPhoto && !compact &&
      <span data-rw="menu-page--meal--photo">
        <MealPhoto
          url={meal.primaryImageUrl}
          alt={meal.name}
        />
      </span>;
    const description = meal.description && !compact &&
      <Description data-rw="menu-page--meal--description">{meal.description}</Description>;
    return (
      <Wrapper
        data-rw="menu-page--meal-component"
        data-rw-meta={`menu-page--meal ${meal.name}`}
      >
        <MealStyled onClick={this.onMealClicked}>
          <MealHeader>
            <MealName data-rw="menu-page--meal--name">
              <Name>{meal.name}</Name>
              {renderImageIcon}
            </MealName>
            <PriceStyled data-rw="menu-page--meal--price">
              <Price amount={meal.price} />
            </PriceStyled>
            <AddMeal
              data-rw="menu-page--meal--add-to-basket-button"
              isDisabled={this.isDisabled}
              onClick={this.onMealClicked}
            >
              {addMealContent}
            </AddMeal>
          </MealHeader>
          {renderPhoto}
          {description}
        </MealStyled>
        <Footer onClick={this.onFooterClick}>
          <AddMealLight
            data-rw="menu-page--meal--add-to-basket-button"
            isDisabled={this.isDisabled}
            onClick={this.onMealClicked}
          >
            {addMealContent}
          </AddMealLight>
          <MealPic
            src={meal.primaryImageUrl}
            img={meal.primaryImageUrl}
          />
        </Footer>
      </Wrapper>
    );
  }
}

Meal.propTypes = {
  meal: PropTypes.object.isRequired,
  restaurantModes: PropTypes.object.isRequired,
  showMealModal: PropTypes.func.isRequired,
  compact: PropTypes.bool,
  handleShowDisabledMealModal: PropTypes.func,
  addItemStraightToBasket: PropTypes.func.isRequired,
  isOfflineMenu: PropTypes.bool.isRequired,
  showMealAddButton: PropTypes.bool.isRequired,
  showMealMoreButton: PropTypes.bool.isRequired,
  serverOffline: PropTypes.bool.isRequired,
  parent: PropTypes.string.isRequired,
  hideDropDownPic: PropTypes.bool,
  handleOpenPictureModal: PropTypes.func
};

export default Meal;



// WEBPACK FOOTER //
// ./components/Meal/Meal.js